import { useReducer } from 'react'

import { useLocalStorage } from 'src/hooks/useLocaleStorage'

import { getFromStorage as getFromSessionStorage } from '../../shared/helpers/sessionStorageHelpers'
import { UserContext, UserDispatchContext } from './constants'
import initialUserState from './initialState'
import UserReducer from './userReducer'

const UserProvider = ({ children }: { children: React.ReactNode }) => {
    const { getFromStorage: getFromLocalStorage } = useLocalStorage()

    const session = getFromSessionStorage('user') || {}
    const activeSession = Object.keys(session).length > 0

    const finalInitialUserState = activeSession ? getFromLocalStorage('user') : initialUserState
    const [user, dispatch] = useReducer(UserReducer, finalInitialUserState)
    return (
        <UserContext.Provider value={user}>
            <UserDispatchContext.Provider value={dispatch}>{children}</UserDispatchContext.Provider>
        </UserContext.Provider>
    )
}

export default UserProvider
